import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {ProgressBar} from "primereact/progressbar";
import {classNames} from "primereact/utils";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {Calendar} from "primereact/calendar";
import {InputText} from "primereact/inputtext";
import {getQueueDirectoriesGetTranksPhones, getQueueDirectoriesQueueAudioType, getQueueId, getQueueIVRType} from "../../../../redux/api/apiQueue";
import {setQueueDialogVisible, setQueueErrorField, setQueueField, setQueueTrankIds, setSelectedQueueIndex} from "../../../../redux/actions/actionsQueue";
import {setEditType as setEditTypeAction, setEditType} from "../../../../redux/actions/actions";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Divider} from "primereact/divider";
import {Dropdown} from "primereact/dropdown";
import {weekdayField} from "../../../../dictionaries";
import {Button} from "primereact/button";
import {getAudioById, isValidAudioGroupId} from "../../../../redux/api/apiAudio";
import AudioDialog from "../../../Settings/AudioList/AudioDialog";

const QueueListDetails = (props: any) => {
    const dispatch = useAppDispatch();
    const queueData = useAppSelector(state => state.QueueListReducer.queueData);
    const loader = useAppSelector(state => state.QueueListReducer.detailsLoading);
    const queuesDirectoryQueueOperatorsType = useAppSelector(state => state.QueueListReducer.queuesDirectoryQueueOperatorsType);
    const queueDataScheduler = useAppSelector(state => state.QueueListReducer.queueData?.scheduler);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const dialerPermissions = checkPermissions(rolesVision, 'Queues');
    const archiveTableToggle = useAppSelector(state => state.QueueListReducer.archiveQueueTableToggle);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [updatedScheduler, setUpdatedScheduler] = useState<any>(null);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const branches = useAppSelector(state => state.UsersListReducer.branches);
    const [selectedPairs, setSelectedPairs] = useState<any>([{selectedGateway: null, selectedPhone: null}]);
    const companiesDirectoryTranksPhones = useAppSelector(state => state.QueueListReducer.queuesDirectoryTrunksPhone);
    const IVRConfiguration = useAppSelector(state => state.QueueListReducer.IVRConfiguration);
    const queuesDirectoryQueueAudioType = useAppSelector(state => state.QueueListReducer.queuesDirectoryQueueAudioType);
    const [audioId, setAudioId] = useState<any>(null)
    const audioPermissions = checkPermissions(rolesVision, 'Audio');
    const detailsLoading = useAppSelector(state => state.AudioListReducer.detailsLoading);
    const trunksIsBlock = !!queueData?.permission?.trunksIsBlock;
    const showTrunksReadOnly = trunksIsBlock;
    const trunksDisplayPairs = showTrunksReadOnly && queueData?.queueTrunks?.length
        ? queueData.queueTrunks.map((queueTrunk: any) => ({
            selectedGateway: queueTrunk.trunkId ?? null,
            selectedPhone: queueTrunk.trunkPhoneId ?? null,
            trunkName: queueTrunk.trunkName,
            phoneNo: queueTrunk.phoneNo,
        }))
        : selectedPairs;
    const trunksPhonesWithPayload = (() => {
        const dict = Array.isArray(companiesDirectoryTranksPhones)
            ? companiesDirectoryTranksPhones
            : [];
        const base = dict.map((item: any) => ({
            ...item,
            sofiaTrunkId: item.sofiaTrunkId ?? item.trunkId ?? item.id,
            profileName: item.profileName ?? item.trunkName ?? item.name,
            phoneNo: item.phoneNo,
            id: item.id ?? item.trunkPhoneId,
        }));
        (queueData?.queueTrunks || []).forEach((queueTrunk: any) => {
            const trunkId = queueTrunk.trunkId;
            const phoneId = queueTrunk.trunkPhoneId;
            if (phoneId == null) {
                return;
            }
            const hasPhone = base.some((item: any) => String(item.id) === String(phoneId));
            if (trunkId != null && !hasPhone) {
                base.push({
                    id: phoneId,
                    sofiaTrunkId: trunkId,
                    profileName: queueTrunk.trunkName,
                    phoneNo: queueTrunk.phoneNo,
                });
            }
        });
        return base;
    })();

    const {
        visible: hasAudioVisiblePermission,
        update: hasAudioUpdatePermission,
    } = audioPermissions;

    const sameAudioId = (a: any, b: any) =>
        a != null && b != null && String(a) === String(b);

    const findAccessibleAudio = (audioId: any) =>
        queuesDirectoryQueueAudioType?.find((audio: any) => sameAudioId(audio.audioId, audioId));

    const canOpenAudioDetails = (audioId: any) => {
        if (loader || queueData?.permission?.audioIsBlock || !hasAudioVisiblePermission || audioId == null) {
            return false;
        }
        const audio = findAccessibleAudio(audioId);
        return isValidAudioGroupId(audio?.groupId);
    };

    const audioDetailsIcon = archiveTableToggle && hasAudioUpdatePermission ? 'pi pi-pencil' : 'pi pi-eye';


    useEffect(() => {
        // Wait until GetQueueById finishes so permission flags are from API, not defaults
        if (loader) {
            return;
        }
        if (!queueData?.queue?.id) {
            return;
        }
        if (!queueData?.permission?.audioIsBlock) {
            dispatch(getQueueDirectoriesQueueAudioType(jwtToken?.jwtToken));
        }
        if (!queueData?.permission?.trunksIsBlock) {
            dispatch(getQueueDirectoriesGetTranksPhones(jwtToken?.jwtToken));
        }
        if (!queueData?.permission?.ivrIsBlock) {
            dispatch(getQueueIVRType(jwtToken?.jwtToken));
        }
    }, [
        loader,
        queueData?.queue?.id,
        queueData?.permission?.audioIsBlock,
        queueData?.permission?.trunksIsBlock,
        queueData?.permission?.ivrIsBlock,
        jwtToken?.jwtToken,
    ]);


    useEffect(() => {
        if (!queueData?.queueTrunks?.length) {
            return;
        }

        const restoredPairs = queueData.queueTrunks.map((queueTrunk: any) => {
            const isEntireGroup = queueTrunk.trunkPhoneId == null;
            const foundByPhone = !isEntireGroup
                ? trunksPhonesWithPayload?.find(
                    (item: any) => String(item.id) === String(queueTrunk.trunkPhoneId)
                )
                : undefined;
            const foundByTrunk = trunksPhonesWithPayload?.find(
                (item: any) => String(item.sofiaTrunkId) === String(queueTrunk.trunkId)
            );
            const found = foundByPhone || foundByTrunk;

            return {
                selectedGateway: queueTrunk.trunkId ?? found?.sofiaTrunkId ?? null,
                selectedPhone: isEntireGroup ? null : (queueTrunk.trunkPhoneId ?? found?.id ?? null),
                trunkName: queueTrunk.trunkName || found?.profileName,
                phoneNo: isEntireGroup ? null : (queueTrunk.phoneNo || found?.phoneNo),
            };
        });

        setSelectedPairs(restoredPairs);
    }, [companiesDirectoryTranksPhones, queueData?.queueTrunks, trunksIsBlock, queueData?.queue?.id]);

    useEffect(() => {
        if (trunksIsBlock) {
            return;
        }
        const result = selectedPairs.map((pair: { selectedGateway: any; selectedPhone: any; }) => ({
            trunkId: pair.selectedGateway ?? null,
            trunkPhoneId: pair.selectedPhone ?? null
        }));
        dispatch(setQueueTrankIds(result));
    }, [selectedPairs, companiesDirectoryTranksPhones, trunksIsBlock]);

    const {
        update: hasQueuesUpdatePermission,
    } = dialerPermissions;

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (queueDataScheduler && queueDataScheduler.days) {
            const labelsMap = weekdayField.reduce((map, weekday) => {
                // @ts-ignore
                map[weekday.dayOfWeek] = weekday.label;
                return map;
            }, {});

            const updatedDays = queueDataScheduler.days.map((day: { dayOfWeek: string | number; label: any; }) => ({
                ...day,
                // @ts-ignore
                label: labelsMap[day.dayOfWeek] || day.label
            }));

            updatedDays.sort((a: { dayOfWeek: number; }, b: { dayOfWeek: number; }) => {
                const dayOfWeekA = a.dayOfWeek === 0 ? 7 : a.dayOfWeek;
                const dayOfWeekB = b.dayOfWeek === 0 ? 7 : b.dayOfWeek;
                return dayOfWeekA - dayOfWeekB;
            });
            setUpdatedScheduler({
                ...queueDataScheduler,
                days: updatedDays
            });
        } else {
            setUpdatedScheduler(queueDataScheduler)
        }
    }, [queueDataScheduler]);

    const operatorsBodyTemplate = () => {
        const activeOperators = queueData?.activeOperators;
        const countOperators = queueData?.countOperators;

        if (activeOperators !== undefined && countOperators !== undefined) {
            return `${activeOperators} / ${countOperators}`;
        }
    }

    const operatorsStrategyBodyTemplate = () => {
        const operatorsStrategy = queueData?.queue?.strategyOperators;
        const foundElement = queuesDirectoryQueueOperatorsType.find((item: { dictionaryId: number; }) => item.dictionaryId === operatorsStrategy);
        if (foundElement) {
            return `${foundElement?.name}`;
        }
    }

    const branchBodyTemplate = () => {
        const names = queueData?.queueBranches?.length
            ? queueData.queueBranches.map((branch: { name?: string }) => branch.name).filter(Boolean).join(', ')
            : (queueData?.queue?.branchName || '');

        return (
            <React.Fragment>
                <span style={{verticalAlign: 'middle'}} className="image-text">
                    {names || '- - -'}
                </span>
            </React.Fragment>
        );
    };

    const fields = [
        {label: "ID", value: queueData?.queue?.id},
        {label: "Branch", value: (queueData?.queueBranches?.length || queueData?.queue?.branchId || queueData?.queue?.branchName) ? branchBodyTemplate() : '- - -'},
        {label: "Транк", value: queueData?.queue?.isQueueTrunk ? 'Транк Черги' : 'Транк Оператора'},
        {label: "Стан", value: queueData?.queue?.isActive ? 'Активна' : 'Не активна'},
        {label: "Приоритет", value: queueData?.queue?.priority || '0'},
        {label: "Оператори:", value: queueData?.countOperators ? operatorsBodyTemplate() : '0 / 0'},
        {label: "Стратегія операторів:", value: queueData?.queue?.strategyOperators ? operatorsStrategyBodyTemplate() : '- - -'},
    ];

    const weekdayBodyTemplate = (days: { [x: string]: any; }, day: number) => {
        const currentDay = days[day];
        const start = days[day]?.start;
        if (!currentDay) {
            return <div className="grid col-12 md:col-12 flex align-items-center" style={{minWidth: '12%'}}>
                - - -
            </div>;
        }
        return (
            <div className="grid flex align-items-center">
                {start ? <div className="col-12 md:col-12 flex align-items-center pl-0" style={{minWidth: '12%'}}>
                        <Calendar disabled className="opacity-100 text-white queue-time" value={new Date(currentDay.start)} timeOnly style={{minWidth: '60px'}}/>
                    </div> :
                    <div className="col-12 md:col-12 flex align-items-center pl-0">
                        <Calendar disabled className="opacity-100 text-white queue-time" value={new Date(currentDay.end)} timeOnly style={{minWidth: '60px'}}/>
                    </div>}
            </div>
        );
    };

    const titleBodyTemplate = (days: { [x: string]: any; }) => {
        const start = days[0]?.start;
        return (
            <div className="grid flex align-items-center">
                {start ? <div className="col-6 md:col-6 flex align-items-center" style={{minWidth: '12%'}}>
                        <div className="mr-2">
                            <label>З</label>
                        </div>
                    </div> :
                    <div className="col-6 md:col-6 flex align-items-center">
                        <div className="mr-2">
                            <label>По</label>
                        </div>
                    </div>}
            </div>
        );
    };


    const openEditor = () => {
        dispatch(setSelectedQueueIndex(queueData.queue?.id || props.selectedRowData));
        dispatch(setQueueDialogVisible(true));
        dispatch(setQueueErrorField(null));
        dispatch(getQueueId(props.selectedRowData, jwtToken?.jwtToken));
        if (hasQueuesUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    }

    let startDates: any = {};
    let endDates: any = {};

    updatedScheduler?.days?.forEach((day: { dayOfWeek: any; start: any; end: any; label: any; }) => {
        const {dayOfWeek, start, end, label} = day;
        startDates[dayOfWeek] = {dayOfWeek, start, label};
        endDates[dayOfWeek] = {dayOfWeek, end, label};
    });

    const formattedBranches = branches?.map((branch: { id: any; name: any; }) => ({
        ...branch,
        label: `${branch.id} ${branch.name}`,
    }));

    const branchItems = queueData?.queueBranches?.map((queueItem: any, index: number) => {
        if (queueData?.permission?.branchIsBlock || queueItem.name) {
            return (
                <div className="field col-12 md:col-10 flex m-0 border-round-sm pl-0" key={queueItem.id || index}>
                    {queueItem.name ? `${queueItem.id} ${queueItem.name}` : queueItem.id}
                </div>
            );
        }
        return formattedBranches?.map((branchItem: any) => {
            if (queueItem.id === branchItem.id) {
                return (
                    <div className="field col-12 md:col-10 flex m-0 border-round-sm pl-0" key={index}>
                        {branchItem.label}
                    </div>
                )
            }
        })
    });

    const audioItemsTable = () => {
        const value = queueData?.permission?.audioIsBlock
            ? (queueData?.queueACD?.ivmAudios || [])
                .map((audioObj: any) => ({
                    ...audioObj,
                    audioName: audioObj.audioName || audioObj.name || '',
                }))
                .sort((a: { order: number; }, b: { order: number; }) => a.order - b.order)
            : queueData?.queueACD?.ivmAudios
                ?.map((audioObj: any) => {
                    const found = queuesDirectoryQueueAudioType?.find((a: any) => sameAudioId(a.audioId, audioObj.audioId));
                    return found
                        ? {...found, order: audioObj.order, audioName: audioObj.audioName || found.audioName}
                        : (audioObj.audioName ? audioObj : null);
                })
                ?.filter(Boolean)
                ?.sort((a: { order: number; }, b: { order: number; }) => a.order - b.order);

        return (
            <DataTable
                value={value}
                reorderableRows={!queueData?.permission?.audioIsBlock}
                style={{minWidth: '200px', maxWidth: '200px'}}
                className="w-full"
            >
                <Column field="order" style={{width: '30px'}}/>
                <Column field="audioName" style={{width: '90%'}}/>
                {windowWidth >= 1248 && !queueData?.permission?.audioIsBlock && hasAudioVisiblePermission && <Column
                    className="px-0"
                    body={(rowData) => {
                        const accessibleAudio = findAccessibleAudio(rowData.audioId);
                        return canOpenAudioDetails(rowData.audioId) ? (
                        <Button
                            icon={audioDetailsIcon}
                            className="p-button-secondary pr-0"
                            loading={rowData?.groupId === audioId && detailsLoading}
                            onClick={() => {
                                if (!accessibleAudio?.groupId) {
                                    return;
                                }
                                dispatch(getAudioById(accessibleAudio.groupId, jwtToken?.jwtToken, true));
                                setAudioId(accessibleAudio.groupId);
                                dispatch(setEditTypeAction(!!hasAudioUpdatePermission));
                            }}
                            disabled={!archiveTableToggle || detailsLoading}
                        />
                        ) : null
                    }}
                />}
            </DataTable>
        );
    };

    const ivrIsBlock = !!queueData?.permission?.ivrIsBlock;
    const ivrConfigLabel = (() => {
        const id = queueData?.queueACD?.ivrConfigurationId;
        const name = queueData?.queueACD?.ivrConfigurationName;
        if (ivrIsBlock) {
            return [id, name].filter((part) => part != null && String(part).trim() !== '').join(' ');
        }
        const ivrCfg = IVRConfiguration?.find(
            (ivr: any) => ivr.flowId === id || ivr.id === id
        );
        if (ivrCfg) {
            return `${ivrCfg.flowId ?? ivrCfg.id} ${ivrCfg.name}`;
        }
        if (name) {
            return [id, name].filter((part) => part != null && String(part).trim() !== '').join(' ');
        }
        return id ? `ID: ${id}` : '';
    })();

    return (
        <div className="">
            <div className="relative">
                {loader && <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>}
                <div className={classNames('grid', {'opacity-50': loader})} style={{paddingTop: "0.3rem", padding: '0.3rem 10px 5px'}}>
                    {windowWidth > 1248 && <div className="grid col-12 md:col-12 mb-0 flex justify-content-between">
                        <div className="field col-12 md:col-6 flex align-items-center flex-wrap m-0">
                            <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                <p className="w-full">ID: {queueData.queue?.id}</p>
                            </div>
                            <div className="field col-12 md:col-8 flex align-items-center m-0 p-0">
                                <p className="w-full">Оператори: {queueData?.countOperators ? operatorsBodyTemplate() : '0 / 0'}</p>
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0 p-0">
                                <p className="w-full">{queueData.queue?.name}</p>
                            </div>
                            <div className="field col-12 md:col-8 flex align-items-center m-0 p-0">
                                <p className="w-full">Стратегія операторів: {queueData?.queue?.strategyOperators ? operatorsStrategyBodyTemplate() : '- - -'}</p>
                            </div>
                        </div>
                        <div className="col-12 md:col-5 flex align-items-center m-0 p-0 justify-content-end text-right">
                            <div className="field col-12 md:col-5 flex align-items-center justify-content-end m-0 p-0">
                                <p className="w-full">Приоритет: {queueData?.queue?.priority || '0'}</p>
                            </div>
                            <div className="field col-12 md:col-5 flex align-items-center justify-content-end m-0 p-0">
                                <p className="w-full">{queueData?.queue?.isActive ? 'Активна' : 'Не активна'}</p>
                            </div>
                            <div className="field col-12 md:col-2 flex align-items-center m-0 p-0">
                                <button className="close-button block cursor-pointer mr-1" onClick={() => {
                                    openEditor();
                                }}><span className={classNames('', {
                                    'pi pi-pencil': archiveTableToggle && hasQueuesUpdatePermission,
                                    'pi pi-eye': !archiveTableToggle || !hasQueuesUpdatePermission
                                })}></span></button>
                                <button className="close-button block cursor-pointer ml-0" onClick={() => props.setSelectedRowData(null)}><span className="pi pi-times"></span></button>
                            </div>
                        </div>
                    </div>}
                    {windowWidth <= 1248 && <div className="grid col-12 md:col-12 mb-0 px-0">
                        <div className="field col-12 md:col-12 flex align-items-center m-0">
                            <p className="w-full">{queueData.queue?.name}</p>
                        </div>
                        {(<div className="field col-12 md:col-12 p-0" style={{margin: 0, borderBottom: '1px solid #cccccc38'}}></div>)}
                    </div>}
                    {windowWidth <= 1248 && <>
                        {fields.map((field: any) => (
                            <React.Fragment key={field.label}>
                                <div className="field col-12 md:col-6 flex align-items-center m-0">
                                    <p>{field.label}</p>
                                </div>
                                <div className="field col-12 md:col-6 flex align-items-center m-0">
                                    <p>{field.value}</p>
                                </div>
                            </React.Fragment>
                        ))}
                        {windowWidth <= 1248 && <div className="field col-12 md:col-12 flex-column flex-wrap mb-0">
                            <div className="field col-12 md:col-12 px-0">
                                <div><label htmlFor="name" className="font-bold text-base">Бранч:</label></div>
                            </div>
                            <div className="field col-12 md:col-12 p-0" style={{margin: 0, borderBottom: '1px solid #cccccc38'}}></div>
                            <div className="field col-12 md:col-12 flex m-0 flex-column px-0">{queueData?.queueBranches?.length ? branchItems : '- - -'}</div>
                        </div>}
                        {updatedScheduler?.days?.length && updatedScheduler?.days ? <div className="grid col-12 md:col-12 flex align-items-center m-0">
                            <div className="col-12 md:col-12 px-0">
                                <p>Розклад роботи:</p>
                            </div>
                            {windowWidth >= 1248 && <div className="col-4 md:col-4 px-0">
                                Графік:
                            </div>}
                            {windowWidth >= 1248 && <div className="col-1 md:col-1 px-0"></div>}
                            {windowWidth >= 1248 && <div className="col-7 md:col-7 pl-4">
                                Розклад дзвінків:
                            </div>}
                        </div> : ''}
                        {queueData?.queue?.queueType !== 702 && updatedScheduler?.days?.length ? updatedScheduler?.days?.map((field: any, index: number) => (
                            <div className="field col-12 md:col-12 mb-0 p-0" key={index}>
                                <div className="grid flex align-items-center">
                                    <div className="col-12 md:col-2">
                                        <InputText type="text" value={field.label} className="opacity-100 w-full text-center" style={{paddingLeft: '2px', paddingRight: '2px'}} placeholder={field.label} disabled/>
                                    </div>
                                    <div className="col-5 md:col-5 flex align-items-center">
                                        <div className="mr-2">
                                            <label>З</label>
                                        </div>
                                        <Calendar disabled className="opacity-100" value={new Date(field?.start)} timeOnly/>
                                    </div>
                                    <div className="col-5 md:col-5 flex align-items-center">
                                        <div className="mr-2">
                                            <label>По</label>
                                        </div>
                                        <Calendar disabled className="opacity-100" value={new Date(field?.end)} timeOnly/>
                                    </div>
                                </div>
                            </div>
                        )) : ''}
                        <Divider className="my-0 mx-2"/>
                        {queueData?.queue?.queueType === 702 && <div className="field col-12 md:col-12 mb-0">
                            <div className="field col-12 md:col-12 flex flex-wrap m-0 p-0">
                                <div className="field col-12 md:col-12 flex align-items-center m-0 p-0 mb-2">
                                    <p className="w-full">{queueData?.queueACD?.isIVMAudio ? 'Аудіо повідомлення' : 'IVR Config'}</p>
                                </div>
                                {/*<div className="field col-12 md:col-12 flex align-items-center m-0 p-0">*/}
                                {/*    <p className="w-full">Кількість відтворень</p>*/}
                                {/*</div>*/}
                                {/*<div className="field col-12 md:col-3 flex align-items-start m-0 p-0 pt-2">*/}
                                {/*    <p className="w-full">{queueData?.queueACD?.audioRetries}</p>*/}
                                {/*</div>*/}
                                <div className="field col-12 md:col-12 flex align-items-center m-0 p-0">
                                    <p className="w-full">{!queueData?.queueACD?.isIVMAudio ? '' : ''}</p>
                                </div>
                                <div className="field col-12 md:col-6 flex align-items-center m-0 p-0">
                                    {!queueData?.queueACD?.isIVMAudio ? (
                                        queueData?.queueACD?.ivrConfigurationId || queueData?.queueACD?.ivrConfigurationName ? (
                                            <InputText
                                                disabled
                                                className="opacity-100"
                                                value={ivrConfigLabel}
                                            />
                                        ) : (
                                            <InputText
                                                disabled
                                                className="opacity-100"
                                                value="IVR конфігурацію не налаштовано"
                                            />
                                        )
                                    ) : <div>{
                                        !!queueData?.queueACD?.ivmAudios?.length &&
                                        <div className="users-list">
                                            {audioItemsTable()}
                                        </div>
                                    }</div>}
                                </div>
                                <div className="field col-12 md:col-12 flex align-items-center m-0 p-0">
                                    <p className="w-full"></p>
                                </div>
                            </div>
                        </div>}
                    </>}
                    {windowWidth > 1248 &&
                        <React.Fragment>
                            <Divider className="my-0"/>
                            <div className="field col-12 md:col-12 flex align-items-center m-0">

                                <div className="field col-12 md:col-3 flex align-items-center m-0 p-0">
                                    <p className="w-full">{queueData?.queue?.isQueueTrunk ? 'Транк Черги' : 'Транк Оператора'}</p>
                                </div>
                                <div className="field col-12 md:col-3 flex align-items-center m-0 p-0">
                                    <p className="w-full">Бранч</p>
                                </div>
                                {queueData?.queue?.queueType !== 702 && <div className="field col-12 md:col-6 flex align-items-center m-0 p-0">
                                    <p className="w-full">Розклад роботи</p>
                                </div>}
                                {queueData?.queue?.queueType === 702 && <div className="field col-12 md:col-6 flex align-items-center m-0 p-0">
                                    <p className="w-full">IVR</p>
                                </div>}
                            </div>
                            <Divider className="my-0"/>
                            <div className="field col-12 md:col-12 flex m-0 scroll-detail-items">
                                <div className="field col-12 md:col-3 flex flex-column m-0 p-0">
                                    {queueData?.queue?.isQueueTrunk && trunksDisplayPairs?.map((pair: { selectedGateway: null; selectedPhone: any; trunkName?: string; phoneNo?: string }, index: number) => {

                                        const usedTrunkIdsWithoutPhone = new Set(
                                            trunksDisplayPairs
                                                .filter((p: { selectedPhone: null; }, i: number) => p.selectedPhone === null && i !== index)
                                                .map((p: { selectedGateway: any; }) => String(p.selectedGateway))
                                        );

                                        const gatewayOptions = Array.from(
                                            new Map(
                                                (trunksPhonesWithPayload || [])
                                                    .filter((item: any) =>
                                                        !usedTrunkIdsWithoutPhone.has(String(item.sofiaTrunkId)) ||
                                                        String(item.sofiaTrunkId) === String(pair.selectedGateway)
                                                    )
                                                    .map((item: any) => [
                                                        item.sofiaTrunkId,
                                                        item.profileName ||
                                                            (String(item.sofiaTrunkId) === String(pair.selectedGateway) ? pair.trunkName : null) ||
                                                            item.sofiaTrunkId,
                                                    ])
                                            ).entries()
                                        ).map(([value, label]) => ({value, label}));
                                        if (
                                            pair.selectedGateway != null &&
                                            !gatewayOptions.some((g) => String(g.value) === String(pair.selectedGateway))
                                        ) {
                                            gatewayOptions.push({
                                                value: pair.selectedGateway,
                                                label: pair.trunkName || pair.selectedGateway,
                                            });
                                        }
                                        const phoneOptions = (trunksPhonesWithPayload || []).filter((item: any) =>
                                            String(item.sofiaTrunkId) === String(pair.selectedGateway) &&
                                            (
                                                !trunksDisplayPairs.some((selectedPair: any, selectedIndex: number) =>
                                                    selectedIndex !== index && String(selectedPair.selectedPhone) === String(item.id)
                                                ) || String(pair.selectedPhone) === String(item.id)
                                            )
                                        );
                                        if (
                                            pair.selectedPhone != null &&
                                            !phoneOptions.some((item: any) => String(item.id) === String(pair.selectedPhone))
                                        ) {
                                            phoneOptions.push({
                                                id: pair.selectedPhone,
                                                sofiaTrunkId: pair.selectedGateway,
                                                profileName: pair.trunkName,
                                                phoneNo: pair.phoneNo || pair.selectedPhone,
                                            });
                                        }
                                        const gatewayLabel = pair.trunkName
                                            || gatewayOptions.find((g) => String(g.value) === String(pair.selectedGateway))?.label
                                            || pair.selectedGateway
                                            || '';
                                        const phoneLabel = pair.selectedPhone != null
                                            ? (pair.phoneNo
                                                || phoneOptions.find((item: any) => String(item.id) === String(pair.selectedPhone))?.phoneNo
                                                || pair.selectedPhone
                                                || '')
                                            : '';
                                        return (<div className="grid col-12 md:col-12 p-0" key={index}>
                                            <div className="field col-12 md:col-5 mb-0 pl-0">
                                                {showTrunksReadOnly ? (
                                                    <InputText className="opacity-100 mr-2 queue-phone w-full bg-transparent" disabled value={String(gatewayLabel)} />
                                                ) : (
                                                <Dropdown
                                                    filter
                                                    emptyMessage="Немає доступних"
                                                    value={pair.selectedGateway}
                                                    options={gatewayOptions}
                                                    optionValue="value"
                                                    optionLabel="label"
                                                    className="opacity-100 mr-2 queue-phone w-full bg-transparent"
                                                    disabled={true}
                                                    placeholder="Оберіть транк"
                                                />
                                                )}
                                            </div>
                                            <div className="field col-12 md:col-7 mb-0">
                                                {showTrunksReadOnly ? (
                                                    <InputText className="opacity-100 queue-phone w-full bg-transparent" disabled value={String(phoneLabel || '')} />
                                                ) : (
                                                <Dropdown
                                                    filter
                                                    value={pair.selectedPhone}
                                                    className="opacity-100 queue-phone w-full bg-transparent"
                                                    optionLabel="phoneNo"
                                                    emptyMessage="Немає доступних"
                                                    optionValue="id"
                                                    options={phoneOptions}
                                                    disabled
                                                    placeholder=""
                                                />
                                                )}
                                            </div>
                                        </div>)
                                    })}
                                </div>
                                <div className="field col-12 md:col-3 flex m-0 p-0 flex-wrap">
                                    {branchItems || '- - -'}
                                </div>
                                {queueData?.queue?.queueType !== 702 && <div className="field col-12 md:col-6 flex m-0 p-0">
                                    {updatedScheduler?.days?.length ?
                                        <DataTable className="col-12 md:col-12 p-0 py-0" value={[startDates, endDates]}>
                                            <Column
                                                header={''}
                                                className="justify-content-start"
                                                body={(data) => titleBodyTemplate(data)}
                                                style={{cursor: 'pointer', width: '5%'}}
                                            />
                                            <Column
                                                header={'Пн'}
                                                className="justify-content-start"
                                                body={(data) => weekdayBodyTemplate(data, 1)}
                                                style={{cursor: 'pointer', width: '12%'}}
                                            />
                                            <Column
                                                header={'Вт'}
                                                className="justify-content-start"
                                                body={(data) => weekdayBodyTemplate(data, 2)}
                                                style={{cursor: 'pointer', width: '12%'}}
                                            />
                                            <Column
                                                header={'Ср'}
                                                className="justify-content-start"
                                                body={(data) => weekdayBodyTemplate(data, 3)}
                                                style={{cursor: 'pointer', width: '12%'}}
                                            />
                                            <Column
                                                header={'Чт'}
                                                className="justify-content-start"
                                                body={(data) => weekdayBodyTemplate(data, 4)}
                                                style={{cursor: 'pointer', width: '12%'}}
                                            />
                                            <Column
                                                header={'Пт'}
                                                className="justify-content-start"
                                                body={(data) => weekdayBodyTemplate(data, 5)}
                                                style={{cursor: 'pointer', width: '12%'}}
                                            />
                                            <Column
                                                header={'Сб'}
                                                className="justify-content-start"
                                                body={(data) => weekdayBodyTemplate(data, 6)}
                                                style={{cursor: 'pointer', width: '12%'}}
                                            />
                                            <Column
                                                header={'Нд'}
                                                className="justify-content-start"
                                                body={(data) => weekdayBodyTemplate(data, 0)}
                                                style={{cursor: 'pointer', width: '12%'}}
                                            />
                                        </DataTable> : '---'}
                                </div>}
                                {queueData?.queue?.queueType === 702 && !!queueData?.queueACD?.isIVMAudio && <div className="field col-12 md:col-6 flex flex-wrap m-0 p-0">
                                    <div className="field col-12 md:col-3 flex align-items-center m-0 p-0">
                                        <p className="w-full">{queueData?.queueACD?.isIVMAudio ? 'Аудіо повідомлення' : 'IVR Config'}</p>
                                    </div>
                                    {/*<div className="field col-12 md:col-3 flex align-items-center m-0 p-0">*/}
                                    {/*    <p className="w-full">Кількість відтворень</p>*/}
                                    {/*</div>*/}
                                    <div className="field col-12 md:col-6 flex align-items-center m-0 p-0">
                                        <p className="w-full">{!queueData?.queueACD?.isIVMAudio ? 'IVR Config' : 'Група аудіо'}</p>
                                    </div>
                                    <div className="field col-12 md:col-3 flex align-items-center m-0 p-0">
                                        <p className="w-full"></p>
                                    </div>
                                    {/*<div className="field col-12 md:col-3 flex align-items-start m-0 p-0 pt-2">*/}
                                    {/*    <p className="w-full">{queueData?.queueACD?.audioRetries}</p>*/}
                                    {/*</div>*/}
                                    <div className="field col-12 md:col-6 flex align-items-center m-0 p-0 pt-2">
                                        {!queueData?.queueACD?.isIVMAudio ? (
                                            queueData?.queueACD?.ivrConfiguration && queueData?.queueACD?.ivrConfiguration.length > 0 ? (
                                                <div className="flex flex-column gap-2">
                                                    {queueData?.queueACD?.ivrConfiguration.map((config: any, index: number) => {
                                                        const ivrConfig = ivrIsBlock
                                                            ? null
                                                            : IVRConfiguration?.find((ivr: any) => ivr.flowId === config.id);
                                                        const configLabel = ivrIsBlock
                                                            ? [config.id ?? config.flowId, config.name].filter((part: any) => part != null && String(part).trim() !== '').join(' ')
                                                            : (ivrConfig?.name || `ID: ${config.flowId}`);
                                                        return (
                                                            <div key={index} className="p-2 border-round surface-border border-1">
                                                                <div className="text-sm mb-1">
                                                                    <span className="text-bold">Конфігурація {index + 1}:</span> {configLabel}
                                                                </div>
                                                                <div className="text-sm">
                                                                    <span className="text-bold">Час:</span> {config.timeStart || '00:00:00'} - {config.timeEnd || '00:00:00'}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <InputText disabled className="opacity-100" value="IVR конфігурації не налаштовані" />
                                            )
                                        ) : <div>{
                                            !!queueData?.queueACD?.ivmAudios?.length &&
                                            <div className="users-list">
                                                {audioItemsTable()}
                                            </div>
                                        }</div>}
                                    </div>
                                </div>}
                                {queueData?.queue?.queueType === 702 && !queueData?.queueACD?.isIVMAudio && (
                                    <div className="field col-12 md:col-6 flex flex-wrap m-0 p-0">
                                        <div className="col-12 mb-3">
                                            {queueData?.queueACD?.ivrConfigurationId || queueData?.queueACD?.ivrConfigurationName ? (
                                                <InputText
                                                    className="opacity-100 mr-2"
                                                    value={ivrConfigLabel}
                                                    disabled
                                                />
                                            ) : (
                                                <div className="text-sm text-color-secondary">
                                                    IVR конфігурацію не налаштовано
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </React.Fragment>
                    }
                </div>
            </div>
            <AudioDialog skipBranchesFetch={queueData?.permission?.branchIsBlock}/>
        </div>
    )
}

export default QueueListDetails
